import Loading from "./Loading";
import LoadingContainer from './LoadingContainer';

Loading.Container = LoadingContainer;

export default Loading;